export default __webpack_public_path__ + "static/media/duvidas.ecc2f124.svg";